import { Section, Subscribe, Course, Container } from "./styles"
import programadorBR from "../../assets/programadorBr.svg"
import jsStack from "../../assets/jstack.svg"
import unopar from "../../assets/unopar.png"


export default function Courses(props) {
  return (
    <Section id="courses">
      <h2>Minhas qualificações</h2>

      <Container>
        <Course
          url={programadorBR}
          width={40}
          height={40}

        >


          <a href="https://programadorbr.com" target="_blank" rel="noreferrer">
            <h3>Programador BR</h3>
          </a>

          <Subscribe>Desenvolvimento Full Stack</Subscribe>
          <p>Iniciei meus estudos como desenvolvedor Full Stack no curso do Programador BR,
            onde adquiri uma base sólida em diversas tecnologias,
            como HTML, CSS, JavaScript, React JS, Node.js, MongoDB e Electron. Aprendi a criar aplicações web completas,
            tanto no frontend quanto no backend, utilizando frameworks populares e ferramentas como React JS e Node.js.
            Adquiri habilidades em desenvolvimento de interfaces responsivas, lógica de programação e integração com bancos de dados.
          </p>
          <span>03/01/2022---12/08/2022</span>
          <a href="https://drive.google.com/drive/folders/1HlXB9Te1KrBsoQRB4NybBQtoDaD7nS_l?usp=sharing" target="_blank" rel="noreferrer">
            <button>Certifcados</button>
          </a>

        </Course>
        <Course
          url={jsStack}
          width={120}
          height={50}

        >
          <a href="https://jstack.com.br" target="_blank" rel="noreferrer">
            <h3></h3>
          </a>
          <Subscribe>Desenvolvimento Full Stack</Subscribe>
          <p>Atualmente, estou aprimorando minhas habilidades como desenvolvedor Full Stack
            por meio do curso JStack, focado no desenvolvimento Full Stack Avançado.
            Meu objetivo é me especializar ainda mais em tecnologias como React e Node.js,
            além de explorar outras ferramentas como React Native, TypeScript, Next.js, testes automatizados, SOLID, arquitetura de software, design patterns e CI/CD. Além disso,
            estou buscando aprender conceitos importantes no mercado para aplicar nos meus projetos.</p>
          <span>Cursando atualmente</span>
          <a href="https://jstack.com.br" target="_blank" rel="noreferrer">
            <button>Conheça o curso</button>
          </a>

        </Course>
        <Course
          url={unopar}
          width={220}
          height={60}
        >
          <a href="https://www.unopar.com.br/curso/analise-e-desenvolvimento-de-sistemas/" target="_blank" rel="noreferrer">
            <h3></h3>
          </a>
          <Subscribe>Análise e Desenvolvimento de Sistemas</Subscribe>
          <p>O curso de Tecnologia em Análise e Desenvolvimento de Sistemas é uma graduação de nível tecnológico que capacita os estudantes a projetar, testar, implantar e gerenciar sistemas e recursos que envolvem hardware e software.
            Durante a graduação, os estudantes desenvolvem habilidades em análise e desenvolvimento de sistemas de informação,
            criação de softwares para uso comercial e gerencial, cálculos e orçamentos de recursos materiais,
            desenvolvimento de aplicações web e móveis, configuração e manutenção de softwares de segurança,
            e controle de qualidade de softwares. Essas habilidades são essenciais para que os graduados possam atender
            às necessidades dos usuários, criar soluções personalizadas, garantir a segurança das aplicações e manter os sistemas
            em funcionamento adequado. A graduação em Análise e Desenvolvimento de Sistemas prepara os estudantes para se tornarem
            profissionais qualificados e atualizados no campo da tecnologia da informação, com capacidade para atender às demandas
            do mercado e contribuir para o desenvolvimento de sistemas e recursos tecnológicos</p>
          <span>Cursando atualmente</span>
          <a href="https://www.unopar.com.br/curso/analise-e-desenvolvimento-de-sistemas/" target="_blank" rel="noreferrer">
            <button>Conheça o curso</button>
          </a>

        </Course>

      </Container>

    </Section >
  );
}


